import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=abb27e46&scoped=true&"
import script from "./NavButton.vue?vue&type=script&lang=ts&"
export * from "./NavButton.vue?vue&type=script&lang=ts&"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=abb27e46&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb27e46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
